import { DayPeriodPicker } from './DayPeriodPicker'
import { TimeZonePicker } from './TimeZonePicker'
import { ChartFormatPicker } from './ChartFormatPicker'

const WINDOW_OPTIONS = [
  { value: 1, label: '1 den' },
  { value: 2, label: '2 dny' },
  { value: 3, label: '3 dny' },
  { value: 4, label: '4 dny' },
]

// Sdílená hlavička pro minutová/hodinová data (10M, HLY) — výběr dne/okna/zarovnání/formátu, viz
// GrafView.jsx a HlyGrafView.jsx (1 stanice) a MeasGrafTable.jsx (skupiny stanic), všechny používají
// stejné rozložení, liší se jen obsType předaný do DayPeriodPickeru.
export function GrafHeaderMin({
  obsType,
  date, onDayChange, isAktual, onAktual,
  windowDays, setWindowDays,
  alignEnd, setAlignEnd,
  useStore,
  tzTrailing,
}) {
  return (
    <div className="flex flex-wrap items-start gap-4">
      <DayPeriodPicker
        date={date}
        onChange={onDayChange}
        obsType={obsType}
        isAktual={isAktual}
        onAktual={onAktual}
        headerExtra={(
          <>
            {/* Velikost okna */}
            <div className="flex flex-col gap-1 shrink-0">
              <span className="text-xs text-gray-400 font-medium uppercase tracking-wide whitespace-nowrap">Velikost okna</span>
              <div className="flex gap-1">
                {WINDOW_OPTIONS.map(opt => (
                  <button
                    key={opt.value}
                    onClick={() => setWindowDays(opt.value)}
                    className={`px-2.5 py-0.5 rounded text-xs font-medium transition-colors border whitespace-nowrap ${
                      windowDays === opt.value
                        ? 'bg-blue-100 text-blue-700 border-blue-300'
                        : 'text-gray-500 border-gray-200 hover:bg-gray-100'
                    }`}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Zarovnání — skryté pro 1 den */}
            {windowDays > 1 && (
              <div className="flex flex-col gap-1 shrink-0">
                <span className="text-xs text-gray-400 font-medium uppercase tracking-wide whitespace-nowrap">Zarovnání</span>
                <div className="flex gap-2 items-center">
                  <label className="flex items-center gap-1 text-xs text-gray-600 cursor-pointer whitespace-nowrap">
                    <input
                      type="radio"
                      name={`alignEnd-${obsType}`}
                      checked={alignEnd}
                      onChange={() => setAlignEnd(true)}
                      className="accent-blue-600"
                    />
                    ke konci
                  </label>
                  <label className="flex items-center gap-1 text-xs text-gray-600 cursor-pointer whitespace-nowrap">
                    <input
                      type="radio"
                      name={`alignEnd-${obsType}`}
                      checked={!alignEnd}
                      onChange={() => setAlignEnd(false)}
                      className="accent-blue-600"
                    />
                    k začátku
                  </label>
                </div>
              </div>
            )}

            <TimeZonePicker trailing={tzTrailing} />
          </>
        )}
      />

      <div className="flex flex-wrap items-start gap-4 ml-auto">
        <ChartFormatPicker useStore={useStore} />
      </div>
    </div>
  )
}
